import { useMarkTrialAsFavorite, useUnMarkTrialAsFavorite } from '@data/hooks';
import { TrialManagementApiSearchRequest } from '@data/sdk/match';

export const useHandleTrialIsFavorite = (
  params?: TrialManagementApiSearchRequest['getTrialsBody'],
) => {
  const { mutate: markTrialAsFavorite } = useMarkTrialAsFavorite();
  const { mutate: unmarkTrialAsFavorite } = useUnMarkTrialAsFavorite();

  const handleIsFavoriteTrial = ({
    trialId,
    isFavorite,
  }: {
    isFavorite?: boolean;
    trialId: string;
  }) =>
    isFavorite
      ? unmarkTrialAsFavorite({ trialId, params })
      : markTrialAsFavorite({ trialId, params });

  return { handleIsFavoriteTrial };
};
